import React from 'react';
import Section from './Section';
import Header from './Header';
import './Body.css';

function Body(props) {
    return (
        <div className="body">
            <Header title={props.main.title} description={props.main.description} additional={props.main.additional} img={props.main.image} />
            {
                props.details.map(function(detail) {
                    return (
                        <Section title={detail.title} description={detail.description} img={detail.img} link={detail.link}/>
                        )
                })
            }
        </div>
    )
}

export default Body;